export default __webpack_public_path__ + "static/media/logo.e360daad.png";